// src/features/permissions/components/PermissionTimelineCard.tsx
import { Card } from '../../../app/components/foundation';
import type { PermissionTimelineEvent } from '../data/permissions.mock';

export interface PermissionTimelineCardProps {
  timeline: PermissionTimelineEvent[];
}

/**
 * Workspace card: chronological timeline for this role (info, update,
 * alert events). Same markup/CSS pattern as
 * audit/components/AuditTimelineCard.tsx,
 * security/components/SecurityTimelineCard.tsx, and
 * monitoring/components/MonitoringTimelineCard.tsx — dot markers
 * colored by event type, event title, timestamp, and description. No
 * new UI pattern introduced.
 */
export function PermissionTimelineCard({ timeline }: PermissionTimelineCardProps) {
  return (
    <Card className="vania-permissions-workspace-card">
      <h2 className="vania-permissions-workspace-card-title">تاریخچه تغییرات</h2>

      {timeline.length === 0 ? (
        <p className="vania-permissions-workspace-empty">رویدادی برای این نقش ثبت نشده است.</p>
      ) : (
        <ol className="vania-permissions-workspace-timeline">
          {timeline.map((event) => (
            <li key={event.id} className="vania-permissions-workspace-timeline-item">
              <span
                aria-hidden
                className={`vania-permissions-workspace-timeline-dot vania-permissions-workspace-timeline-dot-${event.type}`}
              />
              <div className="vania-permissions-workspace-timeline-body">
                <span className="vania-permissions-workspace-timeline-type">{event.title}</span>
                <span className="vania-permissions-workspace-list-secondary">{event.description}</span>
                <span className="vania-permissions-workspace-timeline-date">{event.date}</span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
